// @ts-nocheck
import React from 'react';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { Field as FormikField, FieldProps } from 'formik';
import { DateTime } from 'luxon';
import { InputAdornment, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

export type TDatePickerProps = DatePickerProps<DateTime | null> & {
	name: string;
	clearAble?: boolean;
	valueFormat?: string;
};

function DateField({
	name,
	clearAble = false,
	valueFormat,
	...props
}: TTimeFieldProps) {
	const getDateValue = (value) => {
		if (!value || DateTime.isDateTime(value)) {
			return value || null;
		}

		if (typeof value !== 'string') {
			return null;
		}

		const dates = [
			valueFormat ? DateTime.fromFormat(value, valueFormat) : null,
			DateTime.fromFormat(value, 'd LLLL yyyy', { locale: 'ru' }),
			DateTime.fromFormat(value, 'd MMMM yyyy', { locale: 'ru' }),
			DateTime.fromFormat(value, 'd LLLL yyyy', { locale: 'uk' }),
			DateTime.fromFormat(value, 'd MMMM yyyy', { locale: 'uk' }),
			DateTime.fromISO(value),
			DateTime.fromSQL(value),
		].filter(Boolean);

		return dates.find((date) => date.isValid) || null;
	};

	return (
		<FormikField name={name}>
			{({ field, form }: FieldProps) => (
				<DatePicker
					value={getDateValue(field.value)}
					format={valueFormat}
					onChange={(newValue) => {
						const value =
							valueFormat && typeof field.value === 'string'
								? newValue?.toFormat(valueFormat) ?? ''
								: newValue;

						form.setFieldValue(name, value);
					}}
					slotProps={{
						textField: (params) => ({
							...params,
							InputProps: {
								...params.InputProps,
								endAdornment: (
									<>
										{clearAble && field.value && (
											<InputAdornment position="end">
												<IconButton onClick={() => form.setFieldValue(name, null)} edge="end">
													<ClearIcon />
												</IconButton>
											</InputAdornment>
										)}
										{params.InputProps?.endAdornment}
									</>
								),
							},
						}),
					}}
					{...props}
				/>
			)}
		</FormikField>
	);
}

export default DateField;
